import { AppThunk } from '../../../store/reducers';
import { GET, PUT } from '../../../service/HttpMethod';
import {
	InitialState,
	Lists,
	ProjectSearchLists,
	SearchLists,
	ActionConstant,
	ActionType,
} from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	statusCode: 0,
	projectdetails: [],
	searchhistory: [],
	projectdetailsFetching: true,
	searchhistoryFetching: true,
	count: 0,
	projectsearch: [],
	projectsearchcount: 0,
	projectsearchFetching: true,
};

const GetProjectDetailsAction = (data: Lists): ActionType => ({
	// related to recent projects
	type: ActionConstant.GET_PROJECTS,
	data,
});
const GetProjectSearchDetailsAction = (data: ProjectSearchLists): ActionType => ({
	// related to search
	type: ActionConstant.GET_SEARCH_PROJECTS,
	data,
});
const GetSearchHistoryAction = (data: SearchLists): ActionType => ({
	// recent trade search history fetching
	type: ActionConstant.GET_SEARCHHISTORY,
	data,
});

export const clearProjectDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_PROJECTS,
});
export const clearProjectSearch = (): ActionType => ({
	type: ActionConstant.CLEAR_SEARCH_PROJECTS,
});
export const clearSearchHistory = (): ActionType => ({
	type: ActionConstant.CLEAR_SEARCHHISTORY,
});

export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });

export const getProjectDetails = (data: any = {}): AppThunk => {
	// fetch recent project details
	const getConfig = { url: `users/${data}/projects` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetProjectDetailsAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}		}
	};
};

export const getProjectSearch = (data: any, searchkey: string): AppThunk => {
	const getConfig = { url: `users/${data}/projects?searchKey=${searchkey}` };
	return async (dispatch) => {
		try {
			dispatch(clearProjectSearch());
			const { data = {} } = await GET(getConfig);
			dispatch(GetProjectSearchDetailsAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}		}
	};
};

export const getSearchHistory = (): AppThunk => {
	// recent trade search history
	// project details
	const getConfig = { url: `history` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetSearchHistoryAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}		}
	};
};

export const termsnconditions = (x:any): AppThunk => {
	const data: any = {};
	data.termaAndConditions = x;
	const putConfig = {data, url: `temsAndConditions` };
	return async (dispatch) => {
		try {
			const { status = 0 } = await PUT(putConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}		}
	};
};

function dashboardReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_PROJECTS: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				projectdetails: [...state.projectdetails, ...rows],
				count,
				projectdetailsFetching: false,
			};
		}
		case ActionConstant.GET_SEARCH_PROJECTS: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				projectsearch: [...state.projectsearch, ...rows],
				projectsearchcount: count,
				projectsearchFetching: false,
			};
		}
		case ActionConstant.GET_SEARCHHISTORY: {
			const { searchHistory = [] } = action.data;
			return {
				...state,
				searchhistory: [...state.searchhistory, ...searchHistory],
				searchhistoryFetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_PROJECTS: {
			return {
				...state,
				projectdetails: [],
				count: 0,
				projectdetailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_SEARCH_PROJECTS: {
			return {
				...state,
				projectsearch: [],
				projectsearchcount: 0,
				projectsearchFetching: true,
			};
		}
		case ActionConstant.CLEAR_SEARCHHISTORY: {
			return {
				...state,
				searchhistory: [],
				searchhistoryFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}

		default:
			return state;
	}
}

export default dashboardReducer;
